import React from "react";
import { Photo } from "@/types/photos";
import { FileText } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import PhotoCard from "@/components/PhotoCard";

interface PendingPhotosTabProps {
  photos: Photo[];
  processingId: string | null;
  onApprove: (id: string, customer_email: string) => void;
  onReject: (id: string) => void;
  shopifyConfigured: boolean;
}

const PendingPhotosTab: React.FC<PendingPhotosTabProps> = ({
  photos,
  processingId,
  onApprove,
  onReject,
  shopifyConfigured,
}) => {
  return (
    <>
      {!shopifyConfigured && (
        <div className="mb-4 md:mb-6 rounded-md bg-amber-50 p-3 md:p-4 border border-amber-200">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-4 w-4 md:h-5 md:w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-xs md:text-sm text-amber-700">
                Shopify API is not configured. Go to the Settings tab to set up your Shopify credentials. Until then, mock discount codes will be used.
              </p>
            </div>
          </div>
        </div>
      )}
      {photos.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {photos.map((photo, index) => (
            <FadeIn key={photo.id} delay={index * 50}>
              <PhotoCard
                {...photo}
                onApprove={() => onApprove(photo.id, photo.customerEmail)}
                onReject={onReject}
                isProcessing={processingId === photo.id}
              />
            </FadeIn>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 md:py-12">
          <div className="flex justify-center mb-4 text-muted-foreground">
            <FileText className="h-12 w-12 md:h-16 md:w-16" />
          </div>
          <h3 className="text-base md:text-lg font-medium">No pending photos</h3>
          <p className="text-sm md:text-base text-muted-foreground">
            All submitted photos have been reviewed
          </p>
        </div>
      )}
    </>
  );
};

export default PendingPhotosTab;
